export default "__VITE_ASSET__f9f31053__"